exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.task-activity{margin:18px 25px 12px 9px;width:100%;height:24px;overflow:hidden}.task-activity .detail-section{display:flex;flex-direction:column}.task-activity .detail-section .section-header{display:flex;flex-direction:row;height:32px;position:relative}.task-activity .detail-section .section-header .section-caption{margin-left:16px;font-family:Open Sans,sans-serif;font-weight:600;font-size:14px;color:#2c2c2c;letter-spacing:.5px;text-transform:uppercase}.task-activity .detail-section .section-header .section-icon{cursor:pointer;position:absolute;right:33px;width:16px;height:16px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/TaskCRUD/TaskActivity/TaskActivity.scss
// module id = 1632
// module chunks = 0